import React from 'react';
import { Box, IconButton } from '@mui/material';
import StopIcon from '@mui/icons-material/Stop';

const StreamPlayer = () => {
  return (
    <Box sx={{ position: 'relative', width: '100%', height: '100%', backgroundColor: 'black' }}>
      {/* Stop button */}
      <Box sx={{ position: 'absolute', bottom: '5%', left: '50%', transform: 'translateX(-50%)' }}>
        <IconButton sx={{ color: 'white' }}>
          <StopIcon fontSize="large" />
        </IconButton>
      </Box>
    </Box>
  );
};

export default StreamPlayer;
